<div class="layout-wrapper layout-content-navbar">
    <router-outlet></router-outlet>
    <app-alert></app-alert>

</div>
<div id="template-customizer" class="app-template-customizer invert-bg-white">

</div>